import { NavLink, Outlet, useLocation } from "react-router-dom";
import { AppBar, Box, Tab, Tabs } from '@mui/material'
import { tabStyles } from "../../utils";
import useReduxStore from "../../hooks/useReduxStore";
import { useTranslation } from "react-i18next";
const RevenueReports = () => {
    const { t } = useTranslation();
    const allTabs = [
        {
            label: `${t("boxTitle.booking")}`,
            value: `/reports-analytic/booking`,
        },
        // {
        //     label: `${t("boxTitle.paymentCommission")}`,
        //     value: `/reports-analytic/payment-commission`,
        // },
        {
            label: `${t("boxTitle.Cancelled")}`,
            value: `/reports-analytic/cancelled`,
        },
        {
            label: `${t("boxTitle.completed")}`,
            value: `/reports-analytic/completed`,
        },
        {
            label: `${t("boxTitle.payment")} ${t("boxTitle.refund")}`,
            value: `/reports-analytic/payment-refund`,
        },
        {
            label: `${t("boxTitle.paymentReceived")}`,
            value: `/reports-analytic/payment-received`,
        },
    ];
    const location = useLocation();
    const { selector: dark_mode } = useReduxStore("dark_mode")
    return (
        <>
            <div className='container-fluid d-flex flex-column h-100 custom_scroll' style={{ height: '100%' }}>
                <div>
                    <h1 className='font-18 fw-500 black-color '>Reports & Analytic</h1>
                </div>
                <AppBar position="static" className='border-bottom mt-2  ' sx={{ boxShadow: 'none', background: 'transparent' }}>
                    <Box>
                        <Tabs sx={tabStyles(dark_mode)} variant="scrollable" scrollButtons="auto" value={location.pathname} aria-label="scrollable auto tabs example">
                            {allTabs.map((item, i) =>
                                <Tab key={i}
                                    style={{ textTransform: "capitalize" }}
                                    label={item.label}
                                    value={item.value}
                                    component={NavLink}
                                    to={item.value}
                                />
                            )}
                        </Tabs>
                    </Box>
                </AppBar>
                <Outlet />
            </div >
        </>

    )
}

export default RevenueReports
